type Listener = () => void;

let stale = false;
const listeners = new Set<Listener>();

export const connectionState = {
  isStale(): boolean {
    return stale;
  },
  setStale(next: boolean): void {
    if (stale === next) return;
    stale = next;
    listeners.forEach((listener) => listener());
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
